var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SVGContainer } from ".";
export function Menu(_a) {
    var props = __rest(_a, []);
    return (_jsx(SVGContainer, Object.assign({}, props, { children: _jsx("path", { d: "M0,3V5H18V3Zm0,7H18V8H0Zm0,5H18V13H0Z", fill: "currentColor" }, void 0) }), void 0));
}
//# sourceMappingURL=Menu.js.map